import * as React from 'react';
import styles from './index.less';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import { Space } from 'antd';
// import FInput_MultiLine from '../FInput_MultiLine';
import FInput_PinyinSafeTextCounter_MultiLine from '@/components/FInput_PinyinSafeTextCounter_MultiLine';

interface FIntroductionInputProps {
  value: string;
  title?: string;
  tip?: string;
  btnText?: string;

  onOK(value: string): void;

  onEditingChange?(isEditing: boolean): void;
}

function FIntroductionInput({
  value,
  title = FI18n.i18nNext.t('edit_exhibit_description'),
  tip = FI18n.i18nNext.t('listing_description_info'),
  btnText = FI18n.i18nNext.t('listing_description_btn'),
  onOK,
  onEditingChange,
}: FIntroductionInputProps) {
  const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(false);
  const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
  const [$valueError, set$valueError, get$valueError] = FUtil.Hook.useGetState<string>('');

  function onEdit() {
    set$isEdit(true);
    onEditingChange?.(true);
    set$value(value);
  }

  return (
    <div className={styles.block}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <FComponentsLib.FContentText text={title} type={'highlight'} />

        <Space size={10}>
          {!$isEdit && value !== '' && (
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              onClick={() => {
                onEdit();
              }}
            >
              {FI18n.i18nNext.t('edit')}
            </FComponentsLib.FTextBtn>
          )}
          {$isEdit && (
            <>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                type='default'
                onClick={() => {
                  set$isEdit(false);
                  onEditingChange?.(false);
                }}
              >
                {FI18n.i18nNext.t('cancel')}
              </FComponentsLib.FTextBtn>
              <FComponentsLib.FTextBtn
                style={{ fontSize: 12 }}
                onClick={() => {
                  onOK(get$value());
                  set$isEdit(false);
                  onEditingChange?.(false);
                }}
                disabled={$value.length > 200}
              >
                {FI18n.i18nNext.t('save')}
              </FComponentsLib.FTextBtn>
            </>
          )}
        </Space>
      </div>

      <div style={{ height: 20 }} />
      {$isEdit && (
        <div>
          <FInput_PinyinSafeTextCounter_MultiLine
            value={$value}
            lengthLimit={200}
            onChangeValue={(value) => {
              set$value(value);
            }}
          />

          {$valueError !== '' && (
            <>
              <div style={{ height: 5 }} />
              <div style={{ color: '#EE4040' }}>{$valueError}</div>
            </>
          )}
        </div>
      )}

      {!$isEdit && (
        <>
          {value !== '' ? (
            <div className={styles.aboutPanel}>
              <pre>{value}</pre>
            </div>
          ) : (
            <div>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                }}
              >
                {tip.split('<br />').map((text, textIndex) => {
                  return (
                    <FComponentsLib.FContentText text={text} key={textIndex} type={'additional2'} />
                  );
                })}

                <div style={{ height: 20 }} />
                <FComponentsLib.FRectBtn
                  type='primary'
                  onClick={() => {
                    onEdit();
                  }}
                >
                  {/*添加展品简介*/}
                  {btnText}
                </FComponentsLib.FRectBtn>
              </div>
              <div style={{ height: 20 }} />
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default FIntroductionInput;
